import React from 'react';
import styled from 'styled-components';
import { Step } from '../styles';
import { GridStepWithImage } from '@components';
import { usePresentation } from '@context/presentation';
import { useSlideData } from '@context/slide-data';
import { setStepsReviewed } from '@actions/creators';
import { addStepReviewed } from '@services/sse';
import { updateSavedSteps } from '@utils/browserStorage'; 
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export const GridListOptionStyle = styled(Step)`
    flex-direction: column;
    align-items: ${props => props.alignment ? props.alignment : 'center'};
    justify-content: ${props => props.alignment ? props.alignment : 'center'};
    font-size: ${props => props.theme.smallFont};
    text-align: ${props => props.alignment === 'flex-start' ? 'left' : 'center'};
    height: 100%;
    cursor: pointer;
    position: relative;
    h4 {
        margin-bottom: 7px;
        font-size: ${props => props.headerSize ?? props.theme.mediumFont};
    }
    span.name {
        align-self: flex-end;
        position: absolute;
        right: 10px;
        bottom: 10px;
    }
`;

type GridListOptionProps = {
    option: string,
    label?: string,
    step: number | null,
    imageType: string | IconProp | null,
    alignment?: string,
    headerSize: string | null
}

export const GridListOption = ({ option, imageType = null, step = null, label, alignment, headerSize = null }: GridListOptionProps) => {
    const { clientViewing } = usePresentation();
    const { dispatch, slideState, data } = useSlideData();
    const { stepsReviewed } = slideState;
    const { id: slideId } = data;
    const currentSteps = stepsReviewed[slideId];
    const value = label ?? option;

    const handleClick = (step: string) => {
        if (!clientViewing && !currentSteps.includes(step)) {
            dispatch(setStepsReviewed(slideId, step));
            addStepReviewed({ slideId, step });
            updateSavedSteps(slideId, step);
        }
    };

    return imageType ? (
        <GridStepWithImage 
            name={option} 
            step={step}
            icon={imageType}
            currentSteps={currentSteps}
            handleClick={handleClick} />
        ) : (
        <GridListOptionStyle
            as='li'
            headerSize={headerSize}
            alignment={alignment}
            onClick={() => handleClick(value)}
            value={value}
            selected={currentSteps.includes(value)}>
                {option}
        </GridListOptionStyle>
    );
};

export default GridListOption;
